import { Component, Input, OnInit } from '@angular/core';

export type SpinnerSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl';

@Component({
  standalone: true,
  selector: 'app-loading-spinner',
  templateUrl: './loading-spinner.component.html',
})
export class LoadingSpinnerComponent implements OnInit {
  @Input() size: SpinnerSize = 'md';

  constructor() {}

  ngOnInit() {}

  get sizeClasses(): string {
    const sizeMap = {
      xs: 'h-3 w-3',
      sm: 'h-4 w-4',
      md: 'h-5 w-5',
      lg: 'h-6 w-6',
      xl: 'h-8 w-8',
    };
    return sizeMap[this.size] || 'h-5 w-5';
  }
}
